import React from "react";

export default function ThirdParty() {
  return (
    <>
      <div className="tp-service-5-area  pb-70">
        <div className="container container-1775">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-service-5-title-box text-center">
                <h3 className="tp-hero-3-title tp_reveal_anim ">
                  Third-Party Sharing & Blockchain Transparency
                </h3>
              </div>
            </div>
          </div>
          <div className="">
            <div className="row justify-content-center pt-20">
              <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6">
                <div className="tp-service-5-item tp_fade_bottom space-1">
                  <div className="tp-service-4-content">
                    <h4 className="text-yellow-new tp-service-4-title-sm tp-text-black">
                      <a>Blockchain Data</a>
                    </h4>
                    <p>
                      Your wallet address and NFT transactions are stored on a
                      public blockchain, making them permanently visible.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6">
                <div className="tp-service-5-item tp_fade_bottom space-2">
                  <div className="tp-service-4-content">
                    <h4 className="text-yellow-new tp-service-4-title-sm tp-text-black">
                      <a>No Data Selling</a>
                    </h4>
                    <p>
                      We do not sell, rent, or share personal data with third
                      parties for marketing purposes.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6">
                <div className="tp-service-5-item tp_fade_bottom space-3">
                  <div className="tp-service-4-content">
                    <h4 className="text-yellow-new tp-service-4-title-sm tp-text-black">
                      <a>Third-Party Services</a>
                    </h4>
                    <p>
                      Essential service providers (e.g., payment processors,
                      compliance firms) may process certain transactions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
